import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./CalltoAction.css";
import { ThemeContext } from "./context/themeContext";
import { saveUserHistory } from "./saveUserHistory";
import { useAuth } from "./auth/useAuth";
import { Lightbulb, Network, Sparkles } from "lucide-react";
import IdeaRefinementModal from "./components/IdeaRefinementModal";

export default function CalltoAction({ setToggle, onClose }) {
  const navigate = useNavigate();
  const [activeMode, setActiveMode] = useState(null);
  const [showRefinement, setShowRefinement] = useState(false);
  const { activeTheme } = useContext(ThemeContext);
  const { user } = useAuth();

  const buildFullUrl = (path) => `${process.env.REACT_APP_FRONTEND_URL}${path}`;

  const handleModeClick = async (mode) => {
    if (mode.disabled) {
      setShowRefinement(true);
      return;
    }
    setToggle(false);
    onClose();
    setActiveMode(mode.key);
    setTimeout(async () => {
      await saveUserHistory(buildFullUrl(mode.path), user?.user_id);
      navigate(mode.path, { replace: true });
    }, 250);
  };

  const modes = [
    {
      key: "find",
      icon: <Lightbulb size={15} />,
      label: "Idea Validation",
      path: "/idea-validation",
    },
    {
      key: "generate",
      icon: <Network size={15} />,
      label: "Mind Mapping · Business Hub",
      path: "/mind-mapping",
    },
    {
      key: "refine",
      icon: <Sparkles size={14} />,
      label: "Idea Refinement",
      disabled: true,
    },
  ];

  return (
    <>
      <div className={`cta-modes-section ${activeTheme === "dark" ? "dark-mode" : ""}`}>
        <div className="cta-modes-row">
          {modes.map((mode) => (
            <button
              key={mode.key}
              className={`cta-mode-tab ${activeMode === mode.key ? "active" : ""} ${mode.disabled ? "cta-mode-disabled" : ""}`}
              onClick={() => handleModeClick(mode)}
            >
              <span className="cta-mode-icon">{mode.icon}</span>
              <span className="cta-mode-label">{mode.label}</span>
              {mode.disabled && <span className="cta-mode-soon">Soon</span>}
            </button>
          ))}
        </div>
      </div>

      <IdeaRefinementModal
        show={showRefinement}
        onClose={() => setShowRefinement(false)}
      />
    </>
  );
}
